import { C } from "../constants/colors";

export function EmptyCallouts({ onPost }) {
  return (
    <div className="empty-state">
      <div style={{ width:72,height:72,borderRadius:"50%",background:C.parchD,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.8rem",marginBottom:20 }}>📢</div>
      <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"1.4rem",fontWeight:400,color:C.bark,marginBottom:10 }}>No open calls yet</h2>
      <p style={{ fontSize:".84rem",color:C.muted,lineHeight:1.75,maxWidth:380,marginBottom:24 }}>Post your first open call and start receiving applications from Australian artists.</p>
      <button className="btn-p" onClick={onPost}>+ Post your first open call</button>
      <div style={{ marginTop:16,fontSize:".76rem",color:C.muted,fontFamily:"'DM Mono',monospace" }}>Your 7-day free trial is active — no charge until it ends</div>
    </div>
  );
}

export function EmptyApplications({ onBrowse }) {
  return (
    <div className="empty-state">
      <div style={{ width:72,height:72,borderRadius:"50%",background:C.parchD,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.8rem",marginBottom:20 }}>▤</div>
      <h2 style={{ fontFamily:"'Fraunces',serif",fontSize:"1.4rem",fontWeight:400,color:C.bark,marginBottom:10 }}>No applications yet</h2>
      <p style={{ fontSize:".84rem",color:C.muted,lineHeight:1.75,maxWidth:380,marginBottom:24 }}>Browse open calls and apply to exhibitions, grants and residencies across Australia.</p>
      <button className="btn-p" onClick={onBrowse}>Browse open calls →</button>
      <div style={{ marginTop:16,fontSize:".76rem",color:C.muted,fontFamily:"'DM Mono',monospace" }}>Your 7-day free trial is active — no charge until it ends</div>
    </div>
  );
}
